<div class="criteria-pretitle">
  <label><strong>Criterio {{index + 1}}</strong></label>
  <mat-form-field *ngIf="criterio.niveles.length > 1" appearance="standard" class="level-select">
      <mat-label>Nivel</mat-label>
      <mat-select (selectionChange)="criterioGroup.limpiarFormYGuardar()" [formControl]="nivelForm">
          <mat-option *ngFor="let nivel of criterio.niveles" [value]="nivel.id">
              {{nivel.nickName}}
          </mat-option>
      </mat-select>
  </mat-form-field>
</div>
<p class="criteria-text">{{criterio.nombre}}</p>
<div style="padding-bottom: 16px;">
  <app-retroalimentacion-criterio-control #criterioGroup view="trabajo" [criterio]="criterio" [fecha$]="fecha$"
      [eventoUnidadID]="eventoUnidadId" [alumno]="alumno" [nivelForm]="nivelForm" [alumnos$]="alumnos$" [mostrarAutoevaluacion$]="mostrarAutoevaluacion$"></app-retroalimentacion-criterio-control>
</div>
